(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isHome = document.body.classList.contains('template-index');
      this.isCollection = document.body.classList.contains('template-collection');
      this.mobileHeaderMedia = window.matchMedia('(max-width: 749px), (hover: none), (pointer: coarse)');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    getHeaderExitPoint() {
      return this.headerBounds.bottom || this.header.offsetHeight || 0;
    }

    getHomeHero() {
      return document.querySelector('.section-hcx-hero, .section-hcx-product-slideshow, main .shopify-section:first-child');
    }

    getCollectionHero() {
      return document.querySelector('.hcx-collection-hero--cinematic');
    }

    getHomeHeroHidePoint() {
      if (!this.isHome && !this.isCollection) return 0;

      const hero = this.isHome ? this.getHomeHero() : this.getCollectionHero();
      if (!hero) return 0;

      const headerRect = this.header.getBoundingClientRect();
      const headerBottomLine = Math.max(headerRect.top, 0) + (this.header.offsetHeight || headerRect.height || 0);
      const heroBottom = hero.getBoundingClientRect().bottom + window.scrollY;

      return Math.max(this.getHeaderExitPoint(), heroBottom - headerBottomLine);
    }

    getScrollHidePoint() {
      const homeHeroHidePoint = this.getHomeHeroHidePoint();
      if (homeHeroHidePoint > 0) return homeHeroHidePoint;

      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight
      );
      const scrollableHeight = Math.max(documentHeight - window.innerHeight, 0);

      return Math.max(this.getHeaderExitPoint(), scrollableHeight * 0.05);
    }

    hasOpenHeaderPanel() {
      return Boolean(this.header.querySelector('header-drawer details[open], details-modal details[open]'));
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerExitPoint = this.getHeaderExitPoint();
      const scrollHidePoint = this.getScrollHidePoint();

      if (this.hasOpenHeaderPanel() || (this.predictiveSearch && this.predictiveSearch.isOpen)) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop >= scrollHidePoint) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerExitPoint) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // A scroll frame queued before a menu/search opens must not close it again.
      if (this.hasOpenHeaderPanel()) {
        this.reveal();
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        return;
      }

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
